export default {
  OK: "OK",
  ERROR: "ERROR",
};
